import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import './index.scss';
// IE 11 Polyfills
import 'core-js/features/array/find';
import 'core-js/features/array/find-index';
import 'core-js/features/array/from';
import 'core-js/features/object/assign';
import 'core-js/features/dom-collections';

export const MODAL_ROOT_ID = 'MODAL_ROOT_ID';

const Root = () => {
  return (
    <Router basename="/blindindex2019">
      <Switch>
        <Route path={['/years/:years', '/:companyId', '/']}>
          <App/>
        </Route>
      </Switch>
      <div id={MODAL_ROOT_ID}/>
    </Router>
  );
};

ReactDOM.render(<Root/>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
